import {Component} from '@angular/core';
import {LogMessageService} from '../../services/error/log-message.service';
import {BaseErrorDetailComponent} from '../common/base-error-detail/base-error-detail.component';
import {LogMessage} from '../../models/error/LogMessage';
import {ErrorDetailTemplateComponent} from '../common/error-detail-template/error-detail-template.component';
import {ErrorDetailRuleComponent} from '../common/error-detail-rule/error-detail-rule.component';
import {IonContent} from '@ionic/angular/standalone';
import {CommonModule} from '@angular/common';
import {HeaderComponent} from '../common/header/header.component';

@Component({
    selector: 'app-log-detail',
    templateUrl: './log-detail.component.html',
    styleUrls: ['./log-detail.component.css'],
    imports: [ErrorDetailTemplateComponent, ErrorDetailRuleComponent, IonContent, CommonModule, HeaderComponent],
    standalone: true,
})
export class LogDetailComponent extends BaseErrorDetailComponent<LogMessage> {
    constructor(private logService: LogMessageService) {
        super(logService);
    }
}
